import React from "react";
import { FiMail, FiPhone, FiX } from "react-icons/fi";

const LocationItem = ({ item, onClear, hidePhone }) => {
  if (!item) {
    return null;
  }

  const { id, name, address = {} } = item;
  const { street1, street2, city, state, zip_code, country, phone } = address;

  return (
    <div
      key={id}
      className="address-item card-section col-12 d-flex flex-column justify-content-between"
    >
      <div className="address-info col-12 p-0 d-flex flex-column justify-content-between">
        <div className="d-flex flex-row justify-content-between align-items-center mb-2">
          <h3 className="pickup-point-name">{name}</h3>
          <div className="pickup-point-price-actions d-flex justify-content-end align-items-center">
            <button
              type="button"
              className="pickup-point-icon-btn"
              onClick={onClear}
            >
              <FiX size={20} />
            </button>
          </div>
        </div>
        <p className="address mb-3">
          {`${street1},`}
          {street2 ? ` #${street2},` : null}
          {` ${city}, ${state} ${zip_code}, ${country}`}{" "}
        </p>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div className="email-phone col-12 d-flex p-0 flex-column flex-lg-row justify-content-start flex-wrap">
            {phone && !hidePhone ? (
              <p className="bold d-flex flex-row align-items-center">
                <FiPhone size={20} className="mr-3" />
                {phone}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationItem;
